import {
    EDIT_EVENT,
    GET_ALL_EVENTS,
    SELECT_EVENT
} from '../actions/EventActions'
import { persistReducer } from 'redux-persist';
import storage from 'localforage';

const persistConfig = {
    key: 'events',
    storage,
};

const initialState = {
    data: [],
    totalEvents: 0,
    totalPages: 0,
    currentPage: 1,

    latestUpdate: '',
    loading: false,
    error: '',

    events: null,
    selectedEvent: null,
}

const EventReducer = function (state = initialState, action) {
    switch (action.type) {
        case GET_ALL_EVENTS: {
            return {
                ...state,
                events: action.payload.events,
                selectedEvent: !state.selectedEvent ? action.payload.events[0] : action.payload.events.find((event) => event._id === state.selectedEvent._id)
            }
        }
        case EDIT_EVENT: {
            return {
                ...state,
                events: action.payload.events,
                selectedEvent: action.payload.events.find((event) => event._id === action.payload.eventId)
            }
        }
        case SELECT_EVENT: {
            return {
                ...state,
                selectedEvent: state.events.find((event) => event._id === action.payload.eventId),
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default persistReducer(persistConfig, EventReducer);
